/***
* Add by hxzhu
* created:20190805
* 注:营销活动订单界面
*/
<template>
  <div>
    <div class="pg_body" v-if="ListActOrder.length > 0">
      <div v-for="(items,index) in ListActOrder" :key="index" style="margin-bottom: 10px">
        <div class="Rows_one">
          <font style="float:left;">订单号:{{items.orderId}}</font>
          <template v-if="items.paid == 1">
            <span style="float:right;color:#F1BE36">已支付</span>
          </template>
          <template v-else>
            <span style="float:right;color:#F1BE36">未支付</span>
          </template>
        </div>
        <div class="Rows_two">
          <div style=" display: flex;float: left;width: 30%;height: 100%; margin-right: 5%;align-items: center;">
            <img
              :src="items.avatar"
              alt
              style="width:50%;height:50%;border-radius: 50%"
            />
            <span style="margin-left: 10px;">{{items.nickName}}</span>
          </div>
          <div style="float: left;width: 65%;height: 100%;display: flex;flex-direction: column;place-content:space-around;">
            <div style="color:darkgrey;">{{items.actName}}</div>
            <div style="color:darkgrey;">商品价格:{{items.totalMoney}}元</div>
            <div style="color:darkgrey;" v-if="items.paid == 1">下单时间:{{items.orderTime}}</div>
            <div style="color:darkgrey;" v-else>下单时间:{{items.payTime}}</div>
          </div>
        </div>
      </div>
      <div @click="getMore" v-if="isMore"  style="text-align: center;">更多</div>
     <div  v-else style="text-align: center;">暂无更多</div>
    </div>
    <div class='null' v-else>
      <img class='pic'  src="../../../resource/img/pic_coupon_empty.png" />
      <div>暂无内容</div>
    </div>
  </div>
</template>
<style scoped>
  .pg_body {
    margin-top: 50px;
    padding: 0px 3vw;
  }

  .pg_fool {
    height: 5vh;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
  }

  .order_btn {
    height: 5.5vh;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .Rows_one {
    height: 5vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .Rows_two {
    width: 100vw;
    height: 13vh;
    margin-top: 10px;
    background: rgba(250, 250, 250, 1);
  }

  .pg_foolbtn {
    border-radius: 23px;
    border: 1px solid rgba(155, 155, 155, 1);
    background-color: white;
    width: 25vw;
    outline: none;
    /* background-color: beige; */
  }

  .pg_foolbtnPay {
    border-radius: 23px;
    border: 1px solid rgb(243, 166, 35);
    background-color: white;
    width: 25vw;
    color: rgb(243, 166, 35);
    margin-left: 3vw;
    outline: none;
  }
  .null {
    margin-top: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .null .pic {
    width: 200px;
    height: 200px;
  }
</style>
<script>
  let activityId;
  let uid;
  let page = 1;
  let limit = 2;

  export default {
    name: "MerUnionOrder",
    data() {
      return {
        merId:null,
        storeId:null,
        activityId:null,
        ListActOrder: [],
        openid: "",
        imageUrl: this.$common.URL,
        total:0,
        isMore:true,
        activityType:0
      };
    },
    created() {
      let that = this;
      that.merId = that.$route.query.merId;
      that.activityId = that.$route.query.activityId;
      that.storeId = that.$route.query.storeId;
      that.activityType = that.$route.query.activityType;
      that.getOrderListByActivityId();
    },
    methods: {
      getOrderListByActivityId:function(){
        let that = this;
        that.$axios
          .post(
            "/merchant/api/order/extend-order/mer/find/list",
            that.$qs.stringify({
              merId: that.merId,
              page:page,
              limit:limit,
              activityId:that.activityId,
              activityType:that.activityType
            })
          )
          .then(response => {
            let listr = this.ListActOrder;
            let list = response.data.data;
            let total = response.data.count;
            if(page>1){
              for (let i in list) {
                listr.push(list[i])
              }
            }else{
              listr = list;
            }
            if(total > page*limit){
              this.isMore = true
            }else{
              this.isMore = false
            }
            that.total = response.data.count;
            that.ListActOrder = listr;
          })
          .catch(function(error) {
          });
      },
      // 返回上一层
      goback: function () {
        this.$router.go(-1);
      },
      getMore:function () {
        let totalCounts = this.total;
        if (page * limit >= totalCounts) {
          this.isMore= false
        } else {
          this.isMore= true;
          page = page+1;
          this.getOrderListByActivityId();
        }
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/active/member/MerTokerMerOrder.vue